
<!-- ------------------------------ -->
<!-- Popup Contents -->
<div>
    <!-- ------------------ -->
    <!-- Icon display (CSS class-based) -->
    <div
        *ngIf="data.icon"
        class="flex justify-center items-center"
    >
        <div class="icon-[8rem]" [ngClass]="data.icon"></div>
    </div>

    <!-- Image display (file path-based for illustrations) -->
    <div
        *ngIf="data.imagePath"
        class="flex justify-center items-center mb-3 sm:mb-4"
    >
        <img
            [src]="data.imagePath"
            alt="Dialog illustration"
            class="w-full max-w-[150px] max-h-[135px] sm:max-w-none sm:max-h-none"
            [style.max-width]="data.imageWidth"
            [style.height]="data.imageHeight"
        />
    </div>
    <!-- ------------------ -->
    <!-- Content Texts (Title + Message) -->
    <h1
        *ngIf="data.title"
        class="text-title text-center font-semibold text-xl sm:text-2xl"
        [ngClass]="data.titleClass"
    >
        {{ data.title | translate }}
    </h1>

    <div
        *ngIf="data.message"
        class="text-message text-center text-base font-lato font-medium text-[#4B4848] mt-2 sm:mt-3 max-h-52 overflow-y-auto"
        [innerHTML]="data.message | translate">
    </div>
    <!-- ------------------ -->
</div>
<!-- ------------------------------ -->
<!-- Unable to determine this component past use case yet, as of 2nd December 2025 -->
<!-- <div
    *ngIf="data.isShowAaeInfo"
    class="bg-[#FFF8E5] border-[1px] border-[#FFD058] py-[0.625rem] px-3 w-full rounded-[10px] mt-5 flex items-center space-x-3">
    <mat-icon svgIcon="alert" class="text-[#FFC100] !min-w-5"></mat-icon>
    <div class="text-base font-semibold text-[#5F5B5B] font-lato">
        <p>{{ 'text.note' | translate }}:</p>
        <p [innerHTML]="'text.ourExpertWillRevertToYouWithinDays' | translate"></p>
    </div>
</div> -->
<!-- ------------------------------ -->
<!-- Action Buttons -->
<div
    class="w-full button-holder flex items-center mt-6 justify-center px-2 sm:px-0"
    [ngClass]="{
        'flex-col-reverse space-y-4 space-y-reverse': data.cancelText,
        'sm:flex-row sm:space-y-0 sm:space-x-4': data.cancelText
    }"
>
    <button
        *ngIf="data.cancelText"
        type="button"
        class="font-lato"
        [ngClass]="data.cancelButtonClass || 'flex items-center justify-center h-11 text-primary font-bold text-base bg-white border-[1px] border-primary !rounded-[10px] w-full sm:w-auto sm:min-w-[155px] sm:max-w-[160px]'"
        [mat-dialog-close]="false"
    >
        {{ data.cancelText | translate }}
    </button>
    <button
        type="button"
        [mat-dialog-close]="true"
        class="font-lato"
        [ngClass]="data.confirmButtonClass || 'flex items-center justify-center h-11 !py-2 !rounded-[10px] w-full' + (data.cancelText ? ' sm:w-auto sm:min-w-[155px] sm:max-w-[160px]' : '')"
        [class.btn-warning]="data.isDelete"
        [class.btn-primary]="!data.isDelete"
    >
        {{ data.confirmText | translate }}
    </button>
</div>
<!-- ------------------------------ -->
